module.exports = __webpack_public_path__ + "static/img/zhongzhongka24.7850589.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/zhongzhongka24.png
// module id = zscy
// module chunks = 16